import { useQuery } from '@tanstack/react-query';
import { getTenantGroupInformation } from 'Services';
import { RQ_TENANT_GROUP_INFORMATION } from 'Utils';

const useGetTenantGroupInformation = (tenantKey: string) => {
    return useQuery([RQ_TENANT_GROUP_INFORMATION, tenantKey], () => getTenantGroupInformation());
};

export default useGetTenantGroupInformation;
